import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, TextField } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ActivityAttendanceChart = () => {
  const [activities, setActivities] = useState([]);
  const [chartMonth, setChartMonth] = useState(new Date().toISOString().slice(0, 7));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const acts = await endPoints.getActivitiesAdmin();
        setActivities(Array.isArray(acts) ? acts : []);
      } catch (_e) {
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <Loader fullscreen={false} />;

  const filtered = activities.filter(a => a.date.startsWith(chartMonth));
  const [year, month] = chartMonth.split('-').map(Number);
  const daysInMonth = new Date(year, month, 0).getDate();
  const dayLabels = Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString());

  const dayTotals = Array.from({ length: daysInMonth }, (_, i) => {
    const day = i + 1;
    return filtered
      .filter(a => new Date(a.date).getDate() === day)
      .reduce((sum, a) => sum + (a.registered_attendees || 0), 0);
  });

  const data = {
    labels: dayLabels,
    datasets: [
      {
        label: 'Asistentes',
        data: dayTotals,
        backgroundColor: '#b4c7be'
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    normalized: true,
    elements: {
      bar: {
        borderWidth: 0,
        borderRadius: 2,
      },
    },
    plugins: {
      legend: {
        labels: {
          color: '#4a4a4a',
          font: { size: 14, weight: '600' },
        },
      },
      tooltip: {
        bodyFont: { size: 13 },
        titleFont: { size: 13, weight: '600' },
      },
    },
    scales: {
      x: {
        alignToPixels: true,
        ticks: {
          color: '#555',
          font: { size: 14, weight: '500' },
        },
        grid: { color: '#d9dde1' },
      },
      y: {
        alignToPixels: true,
        beginAtZero: true,
        ticks: {
          color: '#555',
          font: { size: 14, weight: '500' },
        },
        grid: { color: '#d9dde1' },
      },
    },
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardHeader
        title="Asistencia por actividad"
        action={
          <TextField
            label="Mes"
            type="month"
            size="small"
            value={chartMonth}
            onChange={e => setChartMonth(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        }
      />
      <CardContent>
        <Bar
          data={data}
          options={chartOptions}
          style={{ height: 300 }}
        />
      </CardContent>
    </Card>
  );
};

export default ActivityAttendanceChart;
